export default __webpack_public_path__ + "static/media/serch-icon-in-patients-header.31d474d5.svg";